import _ from "lodash";
import React from "react";

import { ACP_NOTE_FIELDS_CAST_TO_BOOLEAN, YES_NO_OPTIONS } from "./constants";
import { AdvancedCareActivityForm } from "./AdvancedCareActivityForm";

export const AdvancedCareActivityViewOnlyForm = ({ note }) => {
  const transformNoteState = () => {
    const copyOfNote = _.cloneDeep(note);

    ACP_NOTE_FIELDS_CAST_TO_BOOLEAN.forEach((item) => {
      const foundOption = YES_NO_OPTIONS.find(
        (option) => option.booleanValue === copyOfNote.content?.[item],
      );

      if (foundOption) {
        copyOfNote.content[item] = foundOption.value;
      }
    });

    return copyOfNote;
  };

  return (
    <AdvancedCareActivityForm
      isEditing={false}
      noteState={transformNoteState(note)}
      patientId={note.patient_id}
    />
  );
};
